module.exports = __webpack_public_path__ + "static/img/bjsjt.1df69aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjsjt.png
// module id = bh8Z
// module chunks = 0